function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  className: "search-icon",
  clipRule: "evenodd",
  d: "M13.6385 14.5813C12.8726 15.058 11.9685 15.3333 11 15.3333C8.23858 15.3333 6 13.0948 6 10.3333C6 7.57192 8.23858 5.33334 11 5.33334C13.7614 5.33334 16 7.57192 16 10.3333C16 11.6438 15.4959 12.8365 14.6709 13.7281L18.4714 17.5286C18.7318 17.789 18.7318 18.2111 18.4714 18.4714C18.2111 18.7318 17.7889 18.7318 17.5286 18.4714L13.6385 14.5813ZM14.6667 10.3333C14.6667 12.3584 13.025 14 11 14C8.97496 14 7.33333 12.3584 7.33333 10.3333C7.33333 8.3083 8.97496 6.66668 11 6.66668C13.025 6.66668 14.6667 8.3083 14.6667 10.3333Z",
  fill: "#908E8E",
  stroke: "#908E8E",
  strokeWidth: 0.4,
  strokeLinecap: "round"
});

function SvgIcSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic-search.e4819039.svg";
export { ForwardRef as ReactComponent };